// 配置全局常量

window.base_image_url = 'https://api.arzu.biz/uploads/images/'
